import React, { Component } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { connect } from 'redaction'
import { mixpanel, constants } from 'common/helpers'
import { toArray } from 'lodash'
import { FormattedHTMLMessage } from 'sb-react-intl'

import Modal from 'components/modal/Modal/Modal'
import Product from 'components/product/Product/Product'

import SkipButton from '../SkipButton/SkipButton'

import messages from './messages'
import s from './ReviewItemListModal.scss'


class ReviewItemListModal extends Component {

  static propTypes = {
    name: PropTypes.string,
  }

  static defaultProps = {
    name: constants.modals.review.ReviewItemList,
  }

  componentDidMount() {
    mixpanel.track(constants.analyticsEvents.reviewPopup)
  }

  handleFragranceButtonClick = (item) => {
    const { name } = this.props

    actions.models.review.setProduct(item)
    actions.models.modals.close(name)
    actions.models.modals.open(constants.modals.review.ReviewComposer, { withItemList: true })
  }

  render() {
    const { name, items, isFirstStep } = this.props

    const metadata          = { placement: 'review item list modal' }
    const snowplowMetadata  = { placement: 'review item list modal' }

    let descriptionMessage = isFirstStep ? messages.descriptionFirst : messages.descriptionThankYou

    if (!isFirstStep && items.length === 1) {
      descriptionMessage = messages.descriptionThankYouOne
    }

    return (
      <Modal
        className={s.modal}
        name={name}
        title={isFirstStep ? messages.titleFirst : messages.titleThankYou}
      >
        <FormattedHTMLMessage
          tag="div"
          {...descriptionMessage}
        />
        <div className={s.items}>
          {
            toArray(items).map((item) => (
              <div key={item.id} className={s.item}>
                <Product
                  data={item}
                  link={false}
                  isQuickViewVisible={false}
                  isHoverEffect={false}
                  isButtonAlways
                  buttonTitle={messages.fragranceButtonTitle}
                  metadata={metadata}
                  snowplowMetadata={snowplowMetadata}
                  onButtonClick={() => this.handleFragranceButtonClick(item)}
                />
              </div>
            ))
          }
        </div>
        {
          !isFirstStep && (
            <SkipButton
              className={s.skipButton}
              modalName={name}
            />
          )
        }
      </Modal>
    )
  }
}


export default connect({
  items: 'models.review.items',
  isFirstStep: 'models.review.isFirstStep',
})(ReviewItemListModal)
